import { useState } from 'react';
import { Image as BootstrapImage } from 'react-bootstrap';

interface UserAvatarProps {
  user: {
    firstName: string;
    lastName: string;
    profileImage?: string;
  };
  size?: number;
  isReply?: boolean;
}

const UserAvatar = ({ user, size = 40, isReply = false }: UserAvatarProps) => {
  const [imageError, setImageError] = useState<boolean>(false);
  const avatarSize = isReply ? size * 0.8 : size;

  const getInitials = (firstName: string, lastName: string) => {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  };

  const getRandomColor = (name: string) => {
    const colors = [
      '#007bff',
      '#6f42c1',
      '#e83e8c',
      '#fd7e14',
      '#ffc107',
      '#28a745',
      '#20c997',
      '#17a2b8',
      '#6c757d',
      '#343a40',
      '#dc3545',
      '#fd7e14'
    ];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  if (user.profileImage && !imageError) {
    return (
      <BootstrapImage
        src={user.profileImage}
        alt={`${user.firstName} ${user.lastName}`}
        roundedCircle
        style={{
          width: `${avatarSize}px`,
          height: `${avatarSize}px`,
          objectFit: 'cover'
        }}
        onError={() => setImageError(true)}
      />
    );
  }

  const initials = getInitials(user.firstName, user.lastName);
  const backgroundColor = getRandomColor(user.firstName + user.lastName);

  return (
    <div
      className="d-flex align-items-center justify-content-center rounded-circle"
      style={{
        width: `${avatarSize}px`,
        height: `${avatarSize}px`,
        backgroundColor,
        color: 'white',
        fontSize: `${avatarSize * 0.4}px`,
        fontWeight: 'bold'
      }}
    >
      {initials}
    </div>
  );
};

export default UserAvatar;
